(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9138],{

/***/ 2467:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/de/manifest",
      function () {
        return __webpack_require__(5066);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 8325:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _mdx_js_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1151);
/* harmony import */ var _MarkdownImage__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4022);
/* harmony import */ var _MarkdownLink__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97);
/* harmony import */ var _Markdown_module_css__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7310);
/* harmony import */ var _Markdown_module_css__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_Markdown_module_css__WEBPACK_IMPORTED_MODULE_4__);
// import node_modules




// import components


// import styles

// define component
var LocalMarkdown = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_Markdown_module_css__WEBPACK_IMPORTED_MODULE_4___default().markdown),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mdx_js_react__WEBPACK_IMPORTED_MODULE_5__/* .MDXProvider */ .Zo, {
            components: {
                StorylinerImage: _MarkdownImage__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z,
                a: _MarkdownLink__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z
            },
            children: children
        })
    });
};
LocalMarkdown.propTypes = {
    children: prop_types__WEBPACK_IMPORTED_MODULE_6__.node.isRequired
};
/* harmony default export */ __webpack_exports__["Z"] = (LocalMarkdown);


/***/ }),

/***/ 4022:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _StorylinerImage__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4090);
// import node_modules



// import components

// define components
var MarkdownImage = function(param) {
    var height = param.height, hasShadow = param.hasShadow, imageId = param.imageId, title = param.title, width = param.width;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "storyliner-markdown-image",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_StorylinerImage__WEBPACK_IMPORTED_MODULE_2__["default"], {
            hasShadow: hasShadow,
            height: height,
            imageId: imageId,
            title: title,
            width: width
        })
    });
};
MarkdownImage.defaultProps = {
    hasShadow: false
};
MarkdownImage.propTypes = {
    hasShadow: prop_types__WEBPACK_IMPORTED_MODULE_3__.bool,
    height: prop_types__WEBPACK_IMPORTED_MODULE_3__.number.isRequired,
    imageId: prop_types__WEBPACK_IMPORTED_MODULE_3__.string.isRequired,
    title: prop_types__WEBPACK_IMPORTED_MODULE_3__.string.isRequired,
    width: prop_types__WEBPACK_IMPORTED_MODULE_3__.number.isRequired
};
/* harmony default export */ __webpack_exports__["Z"] = (MarkdownImage);


/***/ }),

/***/ 97:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _MarkdownLink_module_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5676);
/* harmony import */ var _MarkdownLink_module_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_MarkdownLink_module_css__WEBPACK_IMPORTED_MODULE_3__);
// import node_modules




// import types

// define component
var MarkdownLink = function(param) {
    var children = param.children, href = param.href;
    // storyliner link
    if (href === null || href === void 0 ? void 0 : href.includes("https://storylinerlabs.com")) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
            className: (_MarkdownLink_module_css__WEBPACK_IMPORTED_MODULE_3___default().link),
            href: href.replace("https://storylinerlabs.com", ""),
            passHref: true,
            children: children
        });
    }
    // external link
    if ((href === null || href === void 0 ? void 0 : href.includes("http")) || (href === null || href === void 0 ? void 0 : href.includes("mailto"))) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
            href: href,
            rel: "noopener noreferrer",
            target: "_blank",
            children: children
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
        href: href,
        passHref: true,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
            children: children
        })
    });
};
MarkdownLink.propTypes = {
    children: prop_types__WEBPACK_IMPORTED_MODULE_4__.node.isRequired,
    href: prop_types__WEBPACK_IMPORTED_MODULE_4__.string.isRequired
};
/* harmony default export */ __webpack_exports__["Z"] = (MarkdownLink);


/***/ }),

/***/ 4090:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "StorylinerImage": function() { return /* binding */ StorylinerImage; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var next_legacy_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9755);
/* harmony import */ var next_legacy_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_legacy_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var striptags__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3726);
/* harmony import */ var striptags__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(striptags__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _StorylinerImage_module_css__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(2848);
/* harmony import */ var _StorylinerImage_module_css__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_StorylinerImage_module_css__WEBPACK_IMPORTED_MODULE_5__);
/* eslint-disable react/jsx-props-no-spreading */ // import node_modules






// import styles

// Define component
var StorylinerImage = function(param) {
    var className = param.className, hasShadow = param.hasShadow, hasWhiteBg = param.hasWhiteBg, height = param.height, imageId = param.imageId, isBlack = param.isBlack, isRounded = param.isRounded, isWhite = param.isWhite, title = param.title, width = param.width;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_3___default()((_StorylinerImage_module_css__WEBPACK_IMPORTED_MODULE_5___default().image), isBlack && (_StorylinerImage_module_css__WEBPACK_IMPORTED_MODULE_5___default()["is-black"]), isWhite && (_StorylinerImage_module_css__WEBPACK_IMPORTED_MODULE_5___default()["is-white"]), isRounded && (_StorylinerImage_module_css__WEBPACK_IMPORTED_MODULE_5___default()["is-rounded"]), hasShadow && (_StorylinerImage_module_css__WEBPACK_IMPORTED_MODULE_5___default()["has-shadow"]), hasWhiteBg && (_StorylinerImage_module_css__WEBPACK_IMPORTED_MODULE_5___default()["white-bg"])),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_legacy_image__WEBPACK_IMPORTED_MODULE_2___default()), {
            alt: striptags__WEBPACK_IMPORTED_MODULE_4___default()(title),
            className: className,
            height: height,
            layout: "responsive",
            loading: "lazy",
            src: imageId,
            title: striptags__WEBPACK_IMPORTED_MODULE_4___default()(title),
            width: width
        })
    });
};
StorylinerImage.defaultProps = {
    className: undefined,
    hasShadow: undefined,
    hasWhiteBg: undefined,
    isBlack: false,
    isRounded: true,
    isWhite: false
};
StorylinerImage.propTypes = {
    className: prop_types__WEBPACK_IMPORTED_MODULE_6__.string,
    hasShadow: prop_types__WEBPACK_IMPORTED_MODULE_6__.bool,
    hasWhiteBg: prop_types__WEBPACK_IMPORTED_MODULE_6__.bool,
    height: prop_types__WEBPACK_IMPORTED_MODULE_6__.number.isRequired,
    imageId: prop_types__WEBPACK_IMPORTED_MODULE_6__.string.isRequired,
    isBlack: prop_types__WEBPACK_IMPORTED_MODULE_6__.bool,
    isRounded: prop_types__WEBPACK_IMPORTED_MODULE_6__.bool,
    isWhite: prop_types__WEBPACK_IMPORTED_MODULE_6__.bool,
    title: prop_types__WEBPACK_IMPORTED_MODULE_6__.string.isRequired,
    width: prop_types__WEBPACK_IMPORTED_MODULE_6__.number.isRequired
};
/* harmony default export */ __webpack_exports__["default"] = (StorylinerImage);


/***/ }),

/***/ 3192:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(603);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(5697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _storylinerlabs_design__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4468);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(7058);
/* harmony import */ var jotai_immer__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(8387);
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6198);
/* harmony import */ var _atoms_Section__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9748);
/* harmony import */ var _modules_jotai__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1262);
/* harmony import */ var _EarlyAccessSection_module_css__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(4370);
/* harmony import */ var _EarlyAccessSection_module_css__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_EarlyAccessSection_module_css__WEBPACK_IMPORTED_MODULE_9__);
// import node_modules







// import types

// import components

// import modules

// import styles

// define component
var EarlyAccessSection = function(param) {
    var bgColor = param.bgColor;
    // init hooks
    var _useImmerAtom = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,jotai_immer__WEBPACK_IMPORTED_MODULE_7__/* .useImmerAtom */ .It)(_modules_jotai__WEBPACK_IMPORTED_MODULE_5__/* .earlyAccessModalAtom */ .KR), 2), setEarlyAccessModalState = _useImmerAtom[1];
    var t = (0,react_i18next__WEBPACK_IMPORTED_MODULE_8__/* .useTranslation */ .$)("components").t;
    // init func
    var onOpenModal = react__WEBPACK_IMPORTED_MODULE_1__.useCallback(function() {
        setEarlyAccessModalState(function() {
            return true;
        });
    }, [
        setEarlyAccessModalState
    ]);
    // render section
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_atoms_Section__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP, {
        bgColor: bgColor,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (_EarlyAccessSection_module_css__WEBPACK_IMPORTED_MODULE_9___default()["storyliner-early-access-section"]),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (_EarlyAccessSection_module_css__WEBPACK_IMPORTED_MODULE_9___default()["storyliner-early-access-section-header"]),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_storylinerlabs_design__WEBPACK_IMPORTED_MODULE_2__/* .Heading */ .X6, {
                            alignment: "center",
                            isHyphenated: false,
                            tag: "h2",
                            children: t("EarlyAccessSection.title")
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_storylinerlabs_design__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xv, {
                            alignment: "center",
                            children: t("EarlyAccessSection.intro")
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (_EarlyAccessSection_module_css__WEBPACK_IMPORTED_MODULE_9___default()["storyliner-early-access-button"]),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_storylinerlabs_design__WEBPACK_IMPORTED_MODULE_2__/* .Button */ .zx, {
                            color: "dark",
                            text: t("EarlyAccessSection.callToAction.label"),
                            size: "large",
                            onClick: onOpenModal
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_EarlyAccessSection_module_css__WEBPACK_IMPORTED_MODULE_9___default()["storyliner-early-access-scribble"])
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (_EarlyAccessSection_module_css__WEBPACK_IMPORTED_MODULE_9___default()["storyliner-early-access-section-helptext-container"]),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_storylinerlabs_design__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xv, {
                        alignment: "center",
                        isHelpText: true,
                        size: "small",
                        children: t("EarlyAccessSection.creditCard")
                    })
                })
            ]
        })
    });
};
EarlyAccessSection.defaultProps = {
    bgColor: "white"
};
EarlyAccessSection.propTypes = {
    bgColor: prop_types__WEBPACK_IMPORTED_MODULE_10__.oneOf(Object.values(_types__WEBPACK_IMPORTED_MODULE_3__/* .SectionColorEnum */ .TJ))
};
/* harmony default export */ __webpack_exports__["default"] = (EarlyAccessSection);


/***/ }),

/***/ 5066:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _mdx_js_react__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(1151);
/* harmony import */ var _storylinerlabs_design__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4468);
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6198);
/* harmony import */ var _components_atoms_Column__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4992);
/* harmony import */ var _components_elements_EarlyAccessSection__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3192);
/* harmony import */ var _components_atoms_LocalMarkdown__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8325);
/* harmony import */ var _components_layouts_MainLayout__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(6880);
/* harmony import */ var _components_meta_SEO__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(8897);
/* harmony import */ var _components_atoms_Section__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(9748);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(8362);
/*@jsxRuntime automatic @jsxImportSource react*/ /*import node_modules*/ /*import types*/ /*import components*/ /*import config*/ /*define layout*/ /*Navbar*/ /*define content*/ 










var MDXLayout = function(param) {
    var children = param.children;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_layouts_MainLayout__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
        pathname: _types__WEBPACK_IMPORTED_MODULE_2__/* .RouteEnum.WEBSITE_MANIFESTO_DE */ .gv.WEBSITE_MANIFESTO_DE,
        locale: "de",
        children: [
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_meta_SEO__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                description: "Wir die Kreation von Inhalten um eine neue originelle Art und Weise herum gestaltet, die wir die Storyliner-Philosophie nennen. Mehr erfahren.",
                hrefLang: _types__WEBPACK_IMPORTED_MODULE_2__/* .RouteEnum.WEBSITE_MANIFESTO_EN */ .gv.WEBSITE_MANIFESTO_EN,
                image: "".concat(_config__WEBPACK_IMPORTED_MODULE_9__/* .storylinerRootDomain */ .pk, "/img/screensavers/screensaver-break-creative-barriers-storyliner.jpg"),
                locale: "de",
                pathname: _types__WEBPACK_IMPORTED_MODULE_2__/* .RouteEnum.WEBSITE_MANIFESTO_DE */ .gv.WEBSITE_MANIFESTO_DE,
                title: "Manifest – Die Storyliner-Philosophie - Storyliner"
            }),
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_atoms_Section__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP, {
                children: [
                    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_storylinerlabs_design__WEBPACK_IMPORTED_MODULE_1__/* .Spacer */ .LZ, {
                        height: "64px"
                    }),
                    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_storylinerlabs_design__WEBPACK_IMPORTED_MODULE_1__/* .Spacer */ .LZ, {
                        height: "50px"
                    })
                ]
            }),
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_atoms_Section__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP, {
                children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_atoms_Column__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    cols: "md",
                    children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_atoms_LocalMarkdown__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                        children: children
                    })
                })
            }),
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_atoms_Section__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP, {
                children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_storylinerlabs_design__WEBPACK_IMPORTED_MODULE_1__/* .Spacer */ .LZ, {
                    height: "50px"
                })
            }),
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_atoms_Section__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP, {
                bgColor: "desertStorm",
                children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_storylinerlabs_design__WEBPACK_IMPORTED_MODULE_1__/* .Spacer */ .LZ, {
                    height: "100px"
                })
            }),
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_elements_EarlyAccessSection__WEBPACK_IMPORTED_MODULE_4__["default"], {
                bgColor: "desertStorm"
            }),
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_atoms_Section__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP, {
                bgColor: "desertStorm",
                children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_storylinerlabs_design__WEBPACK_IMPORTED_MODULE_1__/* .Spacer */ .LZ, {
                    height: "100px"
                })
            }),
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_atoms_Section__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP, {
                children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_storylinerlabs_design__WEBPACK_IMPORTED_MODULE_1__/* .Spacer */ .LZ, {
                    height: "50px"
                })
            })
        ]
    });
};
function _createMdxContent(props) {
    var _components = Object.assign({
        p: "p",
        em: "em",
        h2: "h2",
        h3: "h3"
    }, (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_10__/* .useMDXComponents */ .ah)(), props.components);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            "\n",
            "\n",
            "\n",
            "\n",
            "\n",
            "\n",
            "\n",
            "\n",
            "\n",
            "\n",
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_storylinerlabs_design__WEBPACK_IMPORTED_MODULE_1__/* .Heading */ .X6, {
                tag: "label",
                children: "Manifest"
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_storylinerlabs_design__WEBPACK_IMPORTED_MODULE_1__/* .Heading */ .X6, {
                tag: "h1",
                children: "Gro\xdfartige Kommunikation beginnt mit einer Storyline"
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components.p, {
                children: [
                    "Kreatives Denken ist das, was uns als Menschen einzigartig macht. Die Ver\xe4nderungen der letzten Jahrzehnte verlangen von Kommunikatoren und Kreativen, mehr Botschaften in immer k\xfcrzerer Zeit zu produzieren. Hier st\xf6\xdft die menschliche F\xe4higkeit an ihre Grenzen: denn der Prozess wie heute Inhalte produziert werden, ist nicht f\xfcr diese Entwicklungen gemacht. Deshalb haben wir die Kreation von Inhalten um eine neue originelle Art und Weise herum gestaltet, die wir die ",
                    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.em, {
                        children: "Storyliner-Philosophie"
                    }),
                    " nennen. Unsere Beweggr\xfcnde sind im folgenden Manifest dargelegt."
                ]
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.h2, {
                children: "Inhaltserstellung wird m\xfchseliger"
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.p, {
                children: "Die Kreation von Inhalten galt lange Zeit als eine beherrschbare Herausforderung. Inzwischen ist sie zu einer Sisyphusarbeit f\xfcr Kreative geworden: kostspielig, kleinteilig und zeitaufwendig."
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.p, {
                children: "Die Anzahl der Kommunikationskan\xe4le und die Nachfrage nach verschiedenen Formaten explodiert. Kreative m\xfcssen mehr Vielfalt an Inhalten f\xfcr noch mehr Touchpoints schaffen. Die Kosten zur Deckung dieser Nachfrage und die Erwartungen des Publikums steigen rapide, da wir in einer Aufmerksamkeits\xf6konomie leben."
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.p, {
                children: "Es ist an der Zeit, diese Sisyphusarbeit zu beenden. Du verdienst Technologie, die dir hilft, kreativer und produktiver zu werden. Du verdienst einen kreativen Raum, in dem du und dein Team in k\xfcrzester Zeit \xfcberzeugende Storys produzieren k\xf6nnen. Und du verdienst ein Unternehmen und ein Produkt, deren Interessen mit deinen \xfcbereinstimmen."
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components.p, {
                children: [
                    "Das sind wir, das ist ",
                    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.em, {
                        children: "Storyliner"
                    }),
                    "."
                ]
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components.h2, {
                children: [
                    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("s", {
                        children: "Storys kreieren"
                    }),
                    " Mikro-Management"
                ]
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.p, {
                children: "Moderne Software zur Erstellung von Inhalten konzentriert sich auf das Verwalten von Inhalten. Sie l\xf6st entweder eine einzelne Aufgabe oder ist vollgepackt mit Funktionen, aber d\xfcnn an Philosophie. Jeder ist sich selbst \xfcberlassen, ohne Leitprinzipien. Die meisten wissen einfach nicht, wie sie beim Erstellen von Inhalten besser werden k\xf6nnen, und vorhandene Software hilft ihnen nicht weiter."
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components.p, {
                children: [
                    "Was fehlt, ist ein neuer Ansatz, der aus einer anderen Perspektive entstanden ist. Eine v\xf6llig neue Philosophie der Inhaltserstellung. ",
                    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.em, {
                        children: "Storyliner"
                    }),
                    " hat sie. Mit einem neuartigen Design, integrierten Workflows und einer klaren Auffassung hilft dir Storyliner, die Kreation von Inhalten zu meistern."
                ]
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components.p, {
                children: [
                    "Verwende ",
                    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.em, {
                        children: "Storyliner"
                    }),
                    " und folge der ",
                    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.em, {
                        children: "Storyliner-Philosophie"
                    }),
                    ", und du wirst dich garantiert verbessern. Wenige Dinge sind so befriedigend, wie endlich in etwas gut zu werden, mit dem man schon so lange k\xe4mpft."
                ]
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.p, {
                children: "Wir helfen dir, dorthin zu gelangen."
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.h2, {
                children: "Tools, Tools, Tools"
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.p, {
                children: "Bis heute beginnt das Erstellen von Inhalten auf einem leeren Blatt Papier. Eine leere Fl\xe4che mit einem tickenden Cursor. Keine Hilfe f\xfcr das, was zu schreiben ist, oder f\xfcr die Beurteilung der Qualit\xe4t. Ah ja, es gibt ein Tool f\xfcr die Inhaltsanalyse und f\xfcr Notizen und f\xfcr deine Social-Media-Inhalte und f\xfcr die Formatierung und f\xfcr Bilder und f\xfcr den Austausch von Feedback und … Komplexit\xe4t und Ineffizienz!"
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.p, {
                children: "Software wird aus einem Problem heraus geboren oder basiert auf einer neuen Technologie. Wir kennen beide Seiten. Vorhandene Software l\xf6st entweder eine kleine Aufgabe oder versucht, den gesamten Produktions- und Ver\xf6ffentlichungsprozess abzudecken. Der kreative Teil wird vernachl\xe4ssigt oder als Insel dargestellt. Bestehende L\xf6sungen lassen Kreative im Stich und stehen ihnen sogar im Weg."
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.p, {
                children: "Das Erstellen von Inhalten ist einfach zu grundlegend – und zu wichtig – um die M\xf6glichkeiten, die uns gegeben wurden, zu akzeptieren. Jemand muss neues Leben einhauchen und wieder neue Ideen einbringen."
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.p, {
                children: "Wir haben diese Herausforderung angenommen."
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.h2, {
                children: "Die Storyliner-Philosophie"
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components.p, {
                children: [
                    "Die Storyliner-Philosophie basiert im Wesentlichen auf einem Technologie-gest\xfctzten kreativen Prozess. Sie funktioniert am besten, wenn du Inhalte und Kommunikation strategisch planen und entwickeln willst. Im Folgenden findest du eine Liste von Leitlinien, die f\xfcr uns wichtig sind. Und die Pr\xe4missen, die wir ablehnen. ",
                    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.em, {
                        children: "Storyliner"
                    }),
                    " baut auf diesen grundlegenden Ideen und Prinzipien auf. W\xe4hrend die Content-Industrie den kreativen Teil der Inhaltsproduktion jahrelang \xfcbersehen hat, haben wir eine klare Perspektive. Hier sind die S\xe4ulen, an die wir glauben."
                ]
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.h3, {
                children: "#1 Erst die Storyline, dann die Kan\xe4le"
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.p, {
                children: "Storylining wird von allen gro\xdfen Geschichtenerz\xe4hlern oder Kommunikatoren unserer Zeit angewendet. Es ist ein wesentlicher Teil des Storytellings und beim Entwickeln \xfcberzeugender Inhalten. Es ist das Aneinanderreihen von Botschaften in logischer Reihenfolge, um die gesamte Story leicht verst\xe4ndlich und nachvollziehbar zu machen, wobei nur die relevanten Botschaften verwendet und unn\xf6tiger L\xe4rm vermieden wird. Ideal also f\xfcr die Herausforderungen der Unternehmenskommunikation."
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components.p, {
                children: [
                    "Um deutlich effizienter Inhalte f\xfcr verschieden Kommunikationskan\xe4le zu kreieren, entwickelst du mit ",
                    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.em, {
                        children: "Storyliner"
                    }),
                    " zun\xe4chst eine narrative Struktur und die wesentlichen Botschaften einer Story. Daf\xfcr erh\xe4ltst du anhand vordefinierter Genres Inspiration und Empfehlungen. Du kannst auch selbst eigene Erz\xe4hlstrukturen anlegen und die Storylines als Formate abspeichern. Anschlie\xdfend kannst du die Story Technologie-gest\xfctzt in deine Kommunikationskan\xe4le \xfcberf\xfchren. So entstehen \xfcberzeugende Inhalte f\xfcr jeden Ber\xfchrungspunkt mit deinem Publikum."
                ]
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.h3, {
                children: "#2 Teil Maschine, Teil Mensch"
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.p, {
                children: "Die Ver\xe4nderungen der Vergangenheit sind vor allem eines: Technologie-getrieben. Mehr Plattformen, mehr Endger\xe4te, eine zunehmende Anzahl von Inhaltstypen und ein exponentieller Anstieg an ver\xf6ffentlichten Inhalten. Eine Menge die, die menschliche Vorstellungskraft \xfcbersteigt. Warum also mit Werkzeugen letzten Dekade, die n\xe4chste bestreiten?"
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components.p, {
                children: [
                    "Mit ",
                    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.em, {
                        children: "Storyliner"
                    }),
                    " glauben wir das ein Teil des kreativen Prozesses durch eine Maschine gest\xfctzt sein soll, um unsere Kreativit\xe4t zu f\xf6rdern und zu erweitern. Maschinen k\xf6nnen besser Texte verarbeiten, Informationen suchen, Medien editieren oder Vielfalt produzieren. Wir Menschen sind besser im Herstellen von Kontext und im Schaffen von Neuem. Deshalb entwickeln wir Funktionen, die wiederholende T\xe4tigkeiten automatisieren, Workflows optimieren und dich als Nutzer bestm\xf6glich inspirieren."
                ]
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.h3, {
                children: "#3 Notizen erfassen, steigert den kreativen Output"
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.p, {
                children: "Sind wir mal ehrlich: die meisten von uns scheitern mit Produktivit\xe4ts- oder Notizen-Apps. Oftmals liegt es am Verwalten von Informationen. Wir speichern Links, Referenzen oder Inhalte an verschiedenen Orten ab. Beim Hin- und Herkopieren denken wir nicht an die vorgedachte Struktur und verlieren letztendlich den \xdcberblick. Im Team potenziert sich die Frustration, weil jeder von uns eine andere innere Struktur hat und Informationen anders kategorisiert. Wir haben ein Notizen-System entwickelt, dass deinen kreativen Output steigert. Du speicherst Informationsbausteine ab, kannst diese mit Sammlungen verschlagworten und innerhalb von Storys referenzieren. Es gibt keine Hierarchien. So entsteht kein Chaos beim Kategorisieren und Wiederfinden deiner Informationen."
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.h3, {
                children: "#4 Inhalte zusammensetzen, dann verfeinern"
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.p, {
                children: "Beim Storylining werden einzelne Botschaften, Argumente oder Szenen zu einer Erz\xe4hlstruktur aneinandergereiht. Wir nennen diese Bl\xf6cke. Anhand von Bl\xf6cken kannst du deine Ideen zum Konzept und vom Konzept zur Story entwickeln. Du kannst Passagen formatieren, Texte arrangieren, Bilder und Videos einf\xfcgen und den perfekten Workflow f\xfcr dich und dein Team definieren. Mittels Bl\xf6cken wird deine Storyline f\xfcr die einzelnen Kommunikationskan\xe4le aufbereitet. Somit komponierst du zuerst das, was du kommunizieren willst und kannst es dann verfeinern."
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.h3, {
                children: "#5 Integrationen anstatt Silos"
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.p, {
                children: "Im Durchschnitt verwenden Kreative in kleinen bis mittelgro\xdfen Unternehmen 5-7 verschiedene Tools bei der Kreation von Inhalten. Viele der Tools sind propriet\xe4r und erschweren den Transfer der Inhalte. Die Folge sind Technologie-Br\xfcche und Ineffizienz. Wir hingegen glauben an ein offenes Internet und versuchen uns bestm\xf6glich in deine bestehende Technologie-Landschaft zu integrieren. Sei es f\xfcr dein Projektmanagement, Bildbearbeitung oder f\xfcr den Export der Inhalte in andere Plattformen und Tools. Wir sind der Ort an dem du dein Team, deine Daten und deine Inhalte zusammenbringst."
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.h3, {
                children: "#6 Kollaboration mit Zielsetzung"
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components.p, {
                children: [
                    "Die Zeiten der Dateierweiterungen -final.txt, -final-final-2.docx usw. sind vorbei. Mit unserer zentralen Kreativumgebung und den Funktionen zur Zusammenarbeit wirst du und dein Team produktiver und effektiver. Hebe den aktuellen Dokumentstatus hervor, stimme \xfcber \xdcberschriften, Inhalte oder Bilder ab oder arbeite parallel an derselben Story. Wir alle wissen, dass die Entwicklung von Konzepten im Team zu \xfcberzeugenderen Inhalten f\xfchrt. Mit dem ",
                    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.em, {
                        children: "Storyliner"
                    }),
                    " kannst du, das Chaos bei der Zusammenarbeit, beenden und der Zusammenarbeit mit deinem Team einen Sinn geben."
                ]
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.h3, {
                children: "#7 Privatsph\xe4re und Transparenz haben Vorrang"
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components.p, {
                children: [
                    "Gro\xdfe Technologiefirmen dominieren den Software-Markt bei der Kreation von Inhalten. Wir alle kennen ihre werbebasierten Gesch\xe4ftsmodelle. ",
                    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.em, {
                        children: "Storyliner"
                    }),
                    " bietet eine alternative L\xf6sung, ohne die Besessenheit, pers\xf6nliche Daten auszuwerten. Deine Transparenz und Privatsph\xe4re sch\xe4tzen wir. Deshalb sind wir nicht daran interessiert, deine pers\xf6nlichen Daten zu verkaufen; f\xfcr die Nutzung von ",
                    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.em, {
                        children: "Storyliner"
                    }),
                    " berechnen wir lediglich eine monatliche oder j\xe4hrliche Geb\xfchr. Wir bauen gro\xdfartige Produkte und du bezahlst einen vern\xfcnftigen Preis daf\xfcr. Das sorgt daf\xfcr, dass wir unsere Technologie weiterentwickeln k\xf6nnen und macht unser Gesch\xe4ft m\xf6glich, ohne deine Daten weiterzugeben. Das ist fair f\xfcr alle."
                ]
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.h2, {
                children: "Die Zukunft der Inhaltskreation"
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components.p, {
                children: [
                    "Vor uns liegt eine spannende Zukunft mit radikalen Ver\xe4nderungen: faszinierende neue technologische Entwicklungen, die steigende Nachfrage nach \xfcberzeugenden Inhalten und die Intensivierung der Aufmerksamkeits\xf6konomie. Mit ",
                    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.em, {
                        children: "Storyliner"
                    }),
                    " und der ",
                    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.em, {
                        children: "Storyliner-Philosophie"
                    }),
                    " nehmen wir diese Ver\xe4nderungen auf und gestalten sie mit. Unser Ziel ist es, dich auf diesem Weg zu bef\xe4higen, zu begleiten und zu unterst\xfctzen."
                ]
            })
        ]
    });
}
function MDXContent() {
    var props = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(MDXLayout, Object.assign({}, props, {
        children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_createMdxContent, props)
    }));
}
/* harmony default export */ __webpack_exports__["default"] = (MDXContent);


/***/ }),

/***/ 7310:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"markdown":"storyliner-l9a5zk","storyliner-markdown-button":"storyliner-5WQeFL","storyliner-markdown-image":"storyliner-0CMuRb","responsive-iframe":"storyliner-MQtvxX","iframe-wrapper":"storyliner-s6HK1y","optin-canvas":"storyliner-xzbQ5J","info-text":"storyliner-xynJAU","icon-wrapper":"storyliner-HYoR1F","optin-button":"storyliner-0o3hOL"};

/***/ }),

/***/ 5676:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"link":"storyliner-ttPbzh"};

/***/ }),

/***/ 2848:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"image":"storyliner-vbD9mK","fade-in":"storyliner-eNwawO","is-rounded":"storyliner-kV1a7W","is-white":"storyliner-FVEYZh","is-black":"storyliner-dc3Q7B","has-shadow":"storyliner-QcsozF","white-bg":"storyliner-bi4CsT"};

/***/ }),

/***/ 4370:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"storyliner-early-access-section":"storyliner-wwGQfR","storyliner-early-access-section-header":"storyliner-idzssv","storyliner-early-access-button":"storyliner-oIUwVo","storyliner-early-access-scribble":"storyliner-gRgBcx","storyliner-early-access-section-helptext-container":"storyliner-VU7xmS"};

/***/ }),

/***/ 1151:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "NF": function() { return /* binding */ withMDXComponents; },
/* harmony export */   "Zo": function() { return /* binding */ MDXProvider; },
/* harmony export */   "ah": function() { return /* binding */ useMDXComponents; },
/* harmony export */   "pC": function() { return /* binding */ MDXContext; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/**
 * @typedef {import('react').ReactNode} ReactNode
 * @typedef {import('mdx/types').MDXComponents} Components
 *
 * @typedef Props
 *   Configuration.
 * @property {Components} [components]
 *   Mapping of names for JSX components to React components.
 * @property {boolean} [disableParentContext=false]
 *   Turn off outer component context.
 * @property {ReactNode} [children]
 *   Children.
 *
 * @callback MergeComponents
 * @param {Components} currentComponents
 *   Current components from the context.
 * @returns {Components}
 *   Merged components.
 */



/**
 * @type {import('react').Context<Components>}
 * @deprecated
 *   This export is marked as a legacy feature.
 *   That means it’s no longer recommended for use as it might be removed
 *   in a future major release.
 *
 *   Please use `useMDXComponents` to get context based components and
 *   `MDXProvider` to set context based components instead.
 */
const MDXContext = react__WEBPACK_IMPORTED_MODULE_0__.createContext({})

/**
 * @param {import('react').ComponentType<any>} Component
 * @deprecated
 *   This export is marked as a legacy feature.
 *   That means it’s no longer recommended for use as it might be removed
 *   in a future major release.
 *
 *   Please use `useMDXComponents` to get context based components instead.
 */
function withMDXComponents(Component) {
  return boundMDXComponent

  /**
   * @param {Record<string, unknown> & {components?: Components}} props
   * @returns {JSX.Element}
   */
  function boundMDXComponent(props) {
    const allComponents = useMDXComponents(props.components)
    return react__WEBPACK_IMPORTED_MODULE_0__.createElement(Component, {...props, allComponents})
  }
}

/**
 * Get current components from the MDX Context.
 *
 * @param {Components|MergeComponents} [components]
 *   Additional components to use or a function that takes the current
 *   components and filters/merges/changes them.
 * @returns {Components}
 *   Current components.
 */
function useMDXComponents(components) {
  const contextComponents = react__WEBPACK_IMPORTED_MODULE_0__.useContext(MDXContext)
  // Memoize to avoid unnecessary top-level context changes
  return react__WEBPACK_IMPORTED_MODULE_0__.useMemo(() => {
    // Custom merge via a function prop
    if (typeof components === 'function') {
      return components(contextComponents)
    }

    return {...contextComponents, ...components}
  }, [contextComponents, components])
}

/** @type {Components} */
const emptyObject = {}

/**
 * Provider for MDX context
 *
 * @param {Props} props
 * @returns {JSX.Element}
 */
function MDXProvider({components, children, disableParentContext}) {
  let allComponents = useMDXComponents(components)

  if (disableParentContext) {
    allComponents = components || emptyObject
  }

  return react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    MDXContext.Provider,
    {value: allComponents},
    children
  )
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4348,2539,675,6880,5163,9774,2888,179], function() { return __webpack_exec__(2467); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);